module.exports = __webpack_public_path__ + "static/media/login-background.20b39538.jpeg";